<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div class="block--small">
        <transition name="fade" mode="out-in">
            <div>
                <div v-if="registrationComplete">
                    <h3>Account succesvol aangemaakt</h3>
                    <p>Er is een e-mail verstuurd naar e-mailadres. In die e-mail staat hoe u uw registratie kunt afronden.</p>
                    <a href="#" class="button--cta" @click.prevent="changeAuthView('LoginForm')">Terug naar inlogscherm</a>
                </div>

                <form class="form">
                    <h3>Maak account aan </h3>
                    <div class="alert--error" v-if="error !== undefined && error.length > 0">{{error}}</div>
                    <p v-else class="is-muted">* Verplichte velden</p>
                    <h4>Accountgegevens</h4>

                    <div class="form__group">
                        <input class="form__input--text" v-bind:class="{ 'has-error': emailErrorFlag }"  type="text" autocomplete="email" required placeholder="E-mailadres *" v-model="email"/>
                    </div>
                    <div class="form__group">
                        <input class="form__input--text" v-bind:class="{ 'has-error': emailErrorFlag }" type="text" autocomplete="email" required placeholder="Herhaal e-mailadres *" v-model="emailRepeat"/>
                        <span class="form__error_text" v-if="hasEmailError()">{{emailError}}</span>
                    </div>
                    <div class="form__group">
                        <input class="form__input--text" v-bind:class="{ 'has-error': passwordErrorFlag }" type="password" autocomplete="new-password" required placeholder="Wachtwoord *" v-model="password"/>
                    </div>
                    <div class="form__group">
                        <input class="form__input--text" v-bind:class="{ 'has-error': passwordErrorFlag }" type="password" autocomplete="new-password" required placeholder="Herhaal wachtwoord *" v-model="passwordRepeat"/>
                        <span class="form__error_text" v-if="hasPasswordError()">{{passwordError}}</span>
                    </div>

                    <h4>Persoonlijke gegevens</h4>

                    <div class="form__group">
                        <input class="form__input--text" type="text" v-bind:class="{ 'has-error': nameErrorFlag }" placeholder="Voor- en Achternaam *" required autocomplete="name" v-model="userName"/>
                    </div>

                    <div class="form__group">
                        <input class="form__input--text" type="text" placeholder="Telefoonnummer" autocomplete="tel" v-model="phone"/>
                    </div>
                    <div class="form__buttons align-content-end">
                        <button type="submit" class="button--cta" @click.prevent="register">Maak account aan</button>
                        <router-link to="signin" class="button--link">Annuleren</router-link>
                    </div>
                </form>
            </div>
        </transition>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {Emit, Inject, Model, Prop, Provide, Watch } from 'vue-property-decorator';
    import firebase from 'firebase';
//    import {scrollTo} from '@/utils';
    @Component
    export default class RegistrationForm extends Vue {
        name = 'registration-form';
        registrationComplete = false;

        error = '';

        email = '';
        emailRepeat = '';
        emailError = '';
        emailErrorFlag = false;

        password = '';
        passwordRepeat = '';
        passwordError = '';
        passwordErrorFlag = false;

        nameErrorFlag = false;

        userName = '';
        phone = '';

        loading = false;

        changeAuthView(value, event) {
            this.$emit('changeAuthComponent', value);
        }

        register() {
            this.loading = true;
            console.log(firebase.auth().currentUser);
            if (!this.hasEmailError() && !this.hasPasswordError() && this.email !== undefined && this.password !== undefined
                && this.email.length > 0 && this.password.length > 0) {
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then((test) => {
                    console.log(fireabse.auth().currentUser);
                    console.log('SUCCESS', test);

                    //TODO allow photo upload
                    user.updateProfile({
                        displayName: this.userName,
                    }).then(function() {
                        // Update successful.

                        this.loading = false;
                    }).catch(function(error) {
                        // An error happened.
                        this.loading = false;

                    });
                }).catch((error) => {
                    let errorCode = error.code;
                    let message = error.message;
                    
                    console.error('Sign up error', errorCode, message);

                    //TODO multilang error messages
                    switch (errorCode) {
                        case 'auth/invalid-email':
                            this.showError('Your e-mail address is invalid.');
                            break;
                        case 'auth/email-already-in-use':
                            this.showError('This e-mail address is already in use.');
                            break;
                        case 'auth/weak-password':
                            this.showError('Your password is not strong enough. A strong password is at least 6 characters in length and preferably contains both upper- and lowercase letters and numbers.');
                            break;
                        default:
                            this.showError('Something went wrong.');
                            break;
                    }
                })
            } else {
                this.showError('Please fill in all required fields and correct any mistakes.');

                this.emailErrorFlag = (this.email.length > 0 && this.emailError.length === 0);

                this.passwordErrorFlag = (this.password.length > 0 && this.passwordError.length === 0);

                this.nameErrorFlag = this.userName === undefined || this.userName.length === 0;

                this.loading = false;
            }
        }

        @Watch('email')
        @Watch('emailRepeat')
        emailWatcher() {
            let email = this.email;
            let repeat = this.emailRepeat;
            if (email !== undefined && repeat !== undefined &&
                email.length > 0 && repeat.length > 0) {

                //Both fields contain a value. Now compare them.
                if (email !== repeat) {
                    //Display an error.
                    //TODO multilang
                    this.emailError = 'Your e-mail addresses do not match.';
                    this.emailErrorFlag = true;
                } else {
                    this.emailError = '';
                    this.emailErrorFlag = true;
                }
            }
        }

        hasEmailError() {
            return (this.emailError !== undefined && this.emailError.length > 0) || this.emailErrorFlag;
        }

        @Watch('password')
        @Watch('passwordRepeat')
        passwordWatcher() {
            let password = this.password;
            let repeat = this.passwordRepeat;
            if (password !== undefined && repeat !== undefined &&
              password.length > 0 && repeat.length > 0) {

                //Both fields contain a value. Now compare them.
                if (password !== repeat) {
                    //Display an error.
                    //TODO multilang
                    this.passwordError = 'Your passwords do not match.';
                    this.passwordErrorFlag = true;
                } else {
                    this.passwordError = '';
                    this.passwordErrorFlag = false;
                }
            }
        }

        hasPasswordError() {
            return (this.passwordError !== undefined && this.passwordError.length > 0) || this.passwordErrorFlag;
        }

        showError(message) {
            this.error = message;
            scrollTo(document, 0, 2000); //TODO smooth scroll to top
        }
    }

    Vue.component(RegistrationForm.name, RegistrationForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/RegistrationForm.vue